__turbopack_context__.v({
  "authorDetail": "postHeader-module-scss-module__90OEwW__authorDetail",
  "authorDetailWrapper": "postHeader-module-scss-module__90OEwW__authorDetailWrapper",
  "details": "postHeader-module-scss-module__90OEwW__details",
  "postHead": "postHeader-module-scss-module__90OEwW__postHead",
  "takeAwayItems": "postHeader-module-scss-module__90OEwW__takeAwayItems",
  "takeAwayWrapper": "postHeader-module-scss-module__90OEwW__takeAwayWrapper",
  "thumbnail": "postHeader-module-scss-module__90OEwW__thumbnail",
  "title": "postHeader-module-scss-module__90OEwW__title",
  "titleWrapper": "postHeader-module-scss-module__90OEwW__titleWrapper",
});
